/** Porcentajes de IVA admitidos en el formulario de producto (select). */
export type ProductTaxRatePercent = 5 | 19

/**
 * Normaliza tax_rate del API (p. ej. "19.00", 19, 0.19, 0.05) al valor del select (5 o 19).
 */
export function normalizeTaxRatePercent(
  value: unknown,
  fallback: ProductTaxRatePercent = 5
): ProductTaxRatePercent {
  if (value === undefined || value === null || value === '') {
    return fallback
  }
  const n = Number(String(value).replace(',', '.'))
  if (!Number.isFinite(n) || n <= 0) {
    return fallback
  }
  if (n > 0 && n < 1) {
    return n <= 0.06 ? 5 : 19
  }
  const rounded = Math.round(n)
  if (rounded === 5) return 5
  if (rounded === 19) return 19
  return rounded >= 10 ? 19 : 5
}

/** Valor del `<Select>`: vacío si aún no eligió IVA (crear producto). */
export function getTaxRateSelectValue(value: unknown): string {
  if (value === undefined || value === null || value === '') {
    return ''
  }
  const n = Number(String(value).replace(',', '.'))
  if (!Number.isFinite(n) || n <= 0) {
    return ''
  }
  if (n > 0 && n < 1) {
    return n <= 0.06 ? '5' : '19'
  }
  const rounded = Math.round(n)
  if (rounded === 5) return '5'
  if (rounded === 19) return '19'
  return ''
}

export function isValidProductTaxRate(value: unknown): value is ProductTaxRatePercent {
  const v = getTaxRateSelectValue(value)
  return v === '5' || v === '19'
}
